import { useState, useEffect } from 'react';
import api from '../../../../apis';
import Config from '../../../../config';

type BannerItem = { b_id: number; src: string };

const PcsbBanner = () => {
    const [bannerIndex, setBannerIndex] = useState(0);
    const [banners, setBanners] = useState<BannerItem[]>([]);
    const [isPaused, setIsPaused] = useState(false);
    const [loadedIds, setLoadedIds] = useState<Record<number, boolean>>({});

    const prevBanner = () =>
        setBannerIndex((i) => (i - 1 + banners.length) % banners.length);
    const nextBanner = () => setBannerIndex((i) => (i + 1) % banners.length);

    useEffect(() => {
        if (banners.length <= 1 || isPaused) return;
        const timer = setInterval(() => {
            setBannerIndex((i) => (i + 1) % banners.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [banners.length, isPaused]);

    useEffect(() => {
        api.getBroadcastLanding().then((list: any[]) => {
            let items = (list || [])
                .filter((row) => row.b_id)
                .map((row) => ({
                    b_id: row.b_id,
                    src: Config.publicBroadcastUrl +"landing/"+ row.b_id
                }));
            setBanners(items);
        });
    }, []);

    if (banners.length === 0) return null;

    return (
        <section
            className="pcsbHero pcsbContainer"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <button className="pcsbCarouselArrow left" onClick={prevBanner} aria-label="Previous">
                <i className="bi bi-chevron-left"></i>
            </button>

            <div className="pcsbCarouselViewport">
                <div
                    className="pcsbCarouselTrack"
                    style={{ transform: `translateX(-${bannerIndex * 100}%)` }}
                >
                    {banners.map((banner) => (
                        <div className="pcsbCarouselSlide" key={banner.b_id}>
                            <img
                                src={banner.src}
                                alt="-"
                                className={`pcsbSlideImage ${loadedIds[banner.b_id] ? 'loaded' : ''}`}
                                onLoad={() =>
                                    setLoadedIds((prev) => ({ ...prev, [banner.b_id]: true }))
                                }
                            />
                        </div>
                    ))}
                </div>
            </div>

            <button className="pcsbCarouselArrow right" onClick={nextBanner} aria-label="Next">
                <i className="bi bi-chevron-right"></i>
            </button>

            <div className="pcsbCarouselDots">
                {banners.map((b, i) => (
                    <span
                        key={b.b_id}
                        className={i === bannerIndex ? 'active' : ''}
                        onClick={() => setBannerIndex(i)}
                    ></span>
                ))}
            </div>
        </section>
    );
};

export default PcsbBanner;
